exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".youtube-player-container{width:100%;height:100%;max-height:300px}", ""]);

// exports
